var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechatauth"},[_c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"spin"}),_c('p',[_vm._v(_vm._s(_vm.tip))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }